import React, { Component } from 'react'
import { observer } from 'mobx-react'
import style from './style.module.less'
import { EditOutlined, MessageOutlined, PhoneOutlined } from '@ant-design/icons'

@observer
export default class extends Component {
  render() {
    const { newThemeConfig, isThemeBlackGold } = this.props.store
    const color = newThemeConfig['themeColor']

    return (
      <div className={style.bar}>
        <div
          className={style.btns}
          style={{
            color,
            backgroundColor: isThemeBlackGold ? '#000' : '#fff'
          }}
        >
          <div className={style.btn}>
            <MessageOutlined />
            <span>私信</span>
          </div>

          <div className={style.btn}>
            <PhoneOutlined />
            <span>电话</span>
          </div>

          <div className={style.btn}>
            <EditOutlined />
            <span>评价</span>
          </div>
        </div>

        <div
          className={style.appoint}
          style={{
            backgroundColor: color,
            color: isThemeBlackGold ? '#000' : '#fff'
          }}
        >
          预约商家
        </div>
      </div>
    )
  }
}
